import * as _ from "lodash";
import * as React from "react";
import * as ReactBootstrap from "react-bootstrap";
import { notificationStorageKey } from "../App";
var Fade = ReactBootstrap.Fade;
const NotificationMessageNotifier = (props) => {
    const { appState, dispatch } = props.state;
    const updateLocalStorage = (messages) => {
        if (typeof (Storage) !== "undefined") {
            const messageStatuses = (messages || []).map((msg) => ({ id: msg.id, viewed: msg.viewed }));
            localStorage.setItem(notificationStorageKey, JSON.stringify(messageStatuses));
        }
    };
    const getMessagesToUpdate = () => {
        if (!appState.notificationMessages || appState.notificationMessages.length < 1) {
            return [];
        }
        return JSON.parse(JSON.stringify(appState.notificationMessages));
    };
    const handleDismiss = (id) => {
        const updatedMessages = getMessagesToUpdate();
        const message = updatedMessages.find((msg) => msg.id === id);
        if (message) {
            message.viewed = true;
        }
        updateLocalStorage(updatedMessages);
        dispatch({ type: "SET_NOTIFICATION_MESSAGES", notificationMessages: updatedMessages });
    };
    return (React.createElement("div", null,
        appState.notificationMessages.map((message, idx) => (React.createElement(NotificationMessageViewer, { key: message.id, message: message.message, viewed: message.viewed, messageId: message.id, onDismiss: handleDismiss, index: idx }))),
        (!_.isEmpty(appState.notificationMessages) && appState.notificationMessages.some((s) => s.viewed !== true)) && React.createElement("hr", { style: { marginBottom: "10px", borderTopColor: "lightgrey" } })));
};
const NotificationMessageViewer = (props) => {
    const handleDismissClick = () => {
        props.onDismiss(props.messageId);
    };
    return (React.createElement(Fade, { in: !props.viewed, unmountOnExit: true },
        React.createElement("div", { className: "clear" },
            React.createElement("div", { className: "alert alert-warning notification-alert" },
                React.createElement("span", { className: "close", onClick: handleDismissClick, id: `dismiss-notification-${props.index}` }, "\u00D7"),
                React.createElement("p", { className: "alert-text" }, props.message)))));
};
export default NotificationMessageNotifier;
